/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import React from 'react'
import {Helmet} from '../app'

const NoSidebarLayout = ({children}) => {
  return (
    <>
      <Helmet title="Secret of the Source Code" />
      <Block
        overrides={{
          Block: {
            style: {
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: '#0D837E',
              overflowX: 'hidden',
            },
          },
        }}
      >
        {children}
        <Block
          overrides={{
            Block: {
              style: ({$theme}) => ({
                height: 0,
                background: '#0D837E',
                display: 'flex',
                position: 'relative',
                width: 'calc(100% - 48vw)',
                justifyContent: 'space-between',
                paddingTop: $theme.sizing.scale1200,
                [$theme.media.small]: {
                  paddingTop: $theme.sizing.scale2400,
                },
                [$theme.media.large]: {
                  marginTop: $theme.sizing.scale3200,
                  paddingTop: $theme.sizing.scale3200,
                },
                borderBottom: '24vh solid #10B2AE',
                borderLeft: '32vw solid transparent',
                borderRight: '32vw solid transparent',
              }),
            },
          }}
        >
          <Block
            $as="img"
            src="/assets/images/character-guard-one.png"
            alt=""
            overrides={{
              Block: {
                style: ({$theme}) => ({
                  position: 'relative',
                  height: 5 + 'rem',
                  bottom: 2 + 'rem',
                  [$theme.media.small]: {
                    height: 10 + 'rem',
                    bottom: 4 + 'rem',
                  },
                  [$theme.media.large]: {
                    height: 20 + 'rem',
                    bottom: 14 + 'rem',
                  },
                }),
              },
            }}
          />
          <Block
            $as="img"
            src="/assets/images/character-guard-two.png"
            alt=""
            overrides={{
              Block: {
                style: ({$theme}) => ({
                  position: 'relative',
                  height: 5 + 'rem',
                  bottom: 2 + 'rem',
                  [$theme.media.small]: {
                    height: 10 + 'rem',
                    bottom: 4 + 'rem',
                  },
                  [$theme.media.large]: {
                    height: 20 + 'rem',
                    bottom: 14 + 'rem',
                  },
                }),
              },
            }}
          />
        </Block>
      </Block>
    </>
  )
}

export default NoSidebarLayout
